module.exports = __webpack_public_path__ + "static/media/dtrc-inactive.b5ca5977.png";